import React from "react";
import styled from "styled-components";

import { colorFromTheme } from "@examspark/common-ui/dist/utils/color";

import Copyright from "./Copyright";

const Styled = styled.div`
  max-width: var(--app-contain-width);

  margin: 0 auto;
  /* display: flex; */
  gap: 3rem;
  display: grid;
  grid-template-areas:
    "main sidebar"
    "footer sidebar";

  grid-template-columns: 1fr clamp(30ch, 30vw, 30rem);

  // encourage use of semantic elements
  & > main {
    grid-area: main;
  }
  & > aside {
    grid-area: sidebar;
  }
  & > footer {
    grid-area: footer;
  }

  @media (max-width: 600px) {
    & {
      grid-template-areas:
        "main"
        "sidebar"
        "footer";
      grid-template-columns: 1fr;
    }
  }
`;

export const Footer = styled.footer`
  border-top: solid 1px ${colorFromTheme("surface5")};
  /* font-size: var(--font-size-xsmall); */
  font-size: 1.1rem;
  line-height: 1.5em;
  padding-top: 1rem;
  margin-top: 2rem;
  /* color: ${colorFromTheme("secondary", "textColor")}; */
  color: #888;
`;

const PageLayout = (props: React.PropsWithChildren<any>) => {
  return (
    <Styled>
      {props.children}
      <Footer>
        <Copyright />
      </Footer>
    </Styled>
  );
};

export default PageLayout;
